console.log("Track Order JS Loaded");


document.addEventListener("DOMContentLoaded", () => {

    // ==========================================
    // Backend API
    // ==========================================

    const API_URL = "https://synkd-track-order.vercel.app";

    // ==========================================
    // Elements
    // ==========================================

    const emailInput = document.getElementById("track-email");
    const trackingInput = document.getElementById("track-number");
    const trackButton = document.getElementById("track-btn");

    const loading = document.getElementById("loading");
    const result = document.getElementById("result");
    const errorBox = document.getElementById("errorBox");

    const orderNumber = document.getElementById("orderNumber");
    const courier = document.getElementById("courier");
    const tracking = document.getElementById("tracking");
    const service = document.getElementById("service");
    const statusBadge = document.getElementById("statusBadge");

    const productList = document.getElementById("productList");

    const shipStep = document.getElementById("shipStep");
    const deliverStep = document.getElementById("deliverStep");

    // ==========================================
    // Reset Screen
    // ==========================================

    function resetScreen() {

        result.classList.add("hidden");
        errorBox.classList.add("hidden");
        loading.classList.add("hidden");

        productList.innerHTML = "";

        statusBadge.innerHTML = "-";

        shipStep.classList.remove("active");
        deliverStep.classList.remove("active");

    }

    // ==========================================
    // Loading
    // ==========================================

    function startLoading() {

        loading.classList.remove("hidden");

        result.classList.add("hidden");

        errorBox.classList.add("hidden");

        trackButton.disabled = true;

        trackButton.innerHTML = "Searching...";

    }

    function stopLoading() {

        loading.classList.add("hidden");

        trackButton.disabled = false;

        trackButton.innerHTML = "Track Order";

    }

    // ==========================================
    // Status Badge
    // ==========================================

    function updateStatus(status) {

    const value = (status || "").toUpperCase();

    statusBadge.innerHTML = status;

    shipStep.classList.remove("active");
    deliverStep.classList.remove("active");

    statusBadge.style.background = "#64748b";

    if (value.includes("PAID")) {

        statusBadge.style.background = "#2563eb";

    }

    if (
        value.includes("PROCESS") ||
        value.includes("PICK") ||
        value.includes("PACK")
    ) {

        statusBadge.style.background = "#f59e0b";

    }

    if (
        value.includes("SHIPPED") ||
        value.includes("DESPATCH") ||
        value.includes("DISPATCH") ||
        value.includes("RESEND")
    ) {

        statusBadge.style.background = "#10b981";

        shipStep.classList.add("active");

    }

    if (
        value.includes("DELIVER")
    ) {

        statusBadge.style.background = "#059669";

        shipStep.classList.add("active");

        deliverStep.classList.add("active");

    }

    if (
        value.includes("CANCEL")
    ) {

        statusBadge.style.background = "#dc2626";

    }

}


// Courier Logo
function courierLogo(name){

    const value = (name || "").toLowerCase();

    if(value.includes("evri")){
        return "🚚 EVRi";
    }

    if(value.includes("royal")){
        return "📮 Royal Mail";
    }

    if(value.includes("dhl")){
        return "📦 DHL";
    }

    if(value.includes("dpd")){
        return "🚛 DPD";
    }

    return name || "-";
}


// createCopyButton
function createCopyButton(number){

    const old = document.getElementById("copyTracking");

    if(old) old.remove();

    const btn = document.createElement("button");

    btn.id = "copyTracking";

    btn.className = "copy-btn";

    btn.innerHTML = "Copy Tracking Number";

    btn.onclick = () => {

        navigator.clipboard.writeText(number);

        btn.innerHTML = "Copied ✓";

        setTimeout(()=>{

            btn.innerHTML="Copy Tracking Number";

        },2000);

    };

    result.appendChild(btn);

}

// Estimated Delivery
function createEstimatedDelivery(){

    const old = document.getElementById("estimatedDelivery");

    if(old) old.remove();

    const date = new Date();

    date.setDate(date.getDate()+2);

    const div = document.createElement("div");

    div.id="estimatedDelivery";

    div.className="delivery-box";

    div.innerHTML=`

        <strong>Estimated Delivery</strong>

        <div>${date.toLocaleDateString()}</div>

    `;

    result.appendChild(div);

}

    // ==========================================
    // Search Order
    // ==========================================

    async function trackOrder() {

        resetScreen();

        const email = emailInput.value.trim();

        const trackingNumber = trackingInput.value.trim();

        if (!email) {

            alert("Please enter your email.");

            return;

        }

        if (!trackingNumber) {

            alert("Please enter tracking number.");

            return;

        }

        startLoading();

        try {

            const url =
                `${API_URL}/track-order?email=${encodeURIComponent(email)}&trackingNumber=${encodeURIComponent(trackingNumber)}`;

            console.log("Fetching:", url);

            const response = await fetch(url, {

                method: "GET",

                headers: {

                    Accept: "application/json"

                }

            });

            console.log("Status:", response.status);

            const data = await response.json();

            console.log(data);

            stopLoading();

            if (!response.ok || !data.success) {

                errorBox.classList.remove("hidden");

                return;

            }

            // ==========================================
// Show Result
// ==========================================

result.classList.remove("hidden");

// Order Number
orderNumber.textContent = "#" + data.orderNumber;

// Shipping Details
courier.innerHTML = courierLogo(data.courier);

tracking.textContent =
    data.trackingNumber || "-";

service.textContent =
    data.shippingService || "-";

// Status
updateStatus(data.status);
// createEstimatedDelivery();

// createCopyButton(data.trackingNumber);

// ==========================================
// Product List
// ==========================================

productList.innerHTML = "";

if (Array.isArray(data.items) && data.items.length > 0) {

    data.items.forEach(item => {

        const card = document.createElement("div");

        card.className = "track-product";

        card.innerHTML = `

            <div class="track-product-left">

                <div class="product-image">

                    📦

                </div>

                <div>

                    <div class="track-product-title">

                        ${item.name}

                    </div>

                    <div class="track-product-qty">

                        Quantity : ${item.quantity}

                    </div>

                </div>

            </div>

        `;

        productList.appendChild(card);

    });

}
else{

    productList.innerHTML = `

        <div class="track-empty">

            No products found.

        </div>

    `;

}

// ==========================================
// Courier Button
// ==========================================

const oldButton =
    document.getElementById("trackCourierBtn");

if(oldButton){

    oldButton.remove();

}

if(data.trackingNumber){

    const button = document.createElement("a");

    button.id = "trackCourierBtn";

    button.target = "_blank";

    button.className = "track-courier-btn";

    button.innerHTML = "Track Shipment";

    const courierName =
        (data.courier || "").toLowerCase();

    if(courierName.includes("evri")){

        button.href =
        `https://www.evri.com/track/parcel/${data.trackingNumber}`;

    }

    else if(courierName.includes("royal")){

        button.href =
        `https://www.royalmail.com/track-your-item#/tracking-results/${data.trackingNumber}`;

    }

    else{

        button.href = "#";

    }

    result.appendChild(button);

}

// ==========================================
// Scroll Result
// ==========================================

result.scrollIntoView({

    behavior:"smooth",

    block:"start"

});

        }

        catch (err) {

            console.error(err);

            stopLoading();

            errorBox.classList.remove("hidden");

        }

    }

    // ==========================================
    // Events
    // ==========================================

    trackButton.addEventListener("click", trackOrder);

    emailInput.addEventListener("keypress", e => {

        if (e.key === "Enter") {

            trackOrder();

        }

    });

    trackingInput.addEventListener("keypress", e => {

        if (e.key === "Enter") {

            trackOrder();

        }

    });

});